import { BiBarChartAlt2 } from "react-icons/bi";
import { VscLayoutSidebarLeft, VscLayoutSidebarRight } from "react-icons/vsc";
import { HiSearch } from "react-icons/hi";
import "./Sidebar.css";
import SidebarItem from "./SidebarItem";
import SubmenuItem from "./SubmenuItem";
import { useParams } from "react-router-dom";
import { useGetProjectByIdQuery } from "../../store/api/lumi/projects";
import { getSentimentStatus, SENTIMENT_STATUS } from "../../utils/sentimentStatus";
import { VolumeIcon } from "../../icons/VolumeIcon";
import { SentimentIcon } from "../../icons/SentimentIcon";
import { DriversIcon } from "../../icons/DriversIcon";
import React from "react";
import { MdOutlineFiberNew } from "react-icons/md";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { WidgetNames } from "../../constants/WidgetNames";

export function Sidebar({
                            isSidebarOpen,
                            setIsSidebarOpen,
                            metaDataQu,
                        }) {
    const { id } = useParams();
    const { data: project } = useGetProjectByIdQuery(id);

    const sentimentStatus = getSentimentStatus(project);
    const overTimeDisabled = !metaDataQu?.metaDataDate[0]?.name;
    const driversDisabled = !metaDataQu?.metaDataDrivers[0]?.name;
    const sentimentDisabled = sentimentStatus !== SENTIMENT_STATUS.READY;

    const disabledWithoutStringsType = !metaDataQu?.metaDataWithStringType[0]?.name;

    const sidebarItems = [
        {
            text: "Project",
            icon: <AiOutlineFundProjectionScreen color={"#026d8a"} size={32} />,
            children: [
                {
                    text: WidgetNames.TEXT_WIDGET,
                    gridData: {
                        showFilter: false,
                        disable_header: true,
                        title: WidgetNames.TEXT_WIDGET,
                        minH:4,
                        minW: 4,
                        h: 8,
                        w: 4,
                    },
                },
                {
                    text: WidgetNames.DOCUMENTS,
                    gridData: {
                        showFilter: true,
                        title: WidgetNames.DOCUMENTS,
                        without_header: true,
                        h: 5,
                        w: 3,
                        minH: 5,
                        minW: 3,
                    },
                },
                {
                    text: WidgetNames.AVERAGE_SCORE,
                    gridData: {
                        showFilter: true,
                        title: WidgetNames.AVERAGE_SCORE,
                        without_header: true,
                        h: 5,
                        w: 3,
                        minH: 5,
                        minW: 3,
                    },
                    disable: driversDisabled,
                },
                {
                    text: WidgetNames.AVERAGE_SCORE_OVERTIME,
                    gridData: {
                        showFilter: true,
                        title: WidgetNames.AVERAGE_SCORE_OVERTIME,
                        lineChart: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                },
                {
                    text: WidgetNames.SCORE_BREAKDOWN_OVERTIME,
                    gridData: {
                        showFilter: true,
                        lineChart: true,
                        without_header: true,
                        title: WidgetNames.SCORE_BREAKDOWN_OVERTIME,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                },
                {
                    text: WidgetNames.NUMBER_METADATA_BREAKDOWN,
                    gridData: {
                        title: WidgetNames.NUMBER_METADATA_BREAKDOWN,
                        showFilter: true,
                        without_header: true,
                        h: 7,
                        w: 5,
                        minH: 6,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    driversDisabled,
                    overTimeDisabled,
                },{
                    text: WidgetNames.NPS_BREAKDOWN,
                    gridData: {
                        title: WidgetNames.NPS_BREAKDOWN,
                        showFilter: true,
                        without_header: true,
                        h: 7,
                        w: 5,
                        minH: 7,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    driversDisabled,
                    overTimeDisabled,
                },
                {
                    text: WidgetNames.NPS_SCORE,
                    gridData: {
                        title: WidgetNames.NPS_SCORE,
                        showFilter: true,
                        without_header: true,
                        h: 5,
                        w: 3,
                        minH: 5,
                        minW: 3,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    driversDisabled,
                    overTimeDisabled,
                },
                {
                    text: WidgetNames.NPS_SCORE_OVERTIME,
                    gridData: {
                        title: WidgetNames.NPS_SCORE_OVERTIME,
                        showFilter: true,
                        without_header: true,
                        h: 10,
                        w: 5,
                        minH: 10,
                        minW: 5,
                        lineChart: true,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    driversDisabled,
                    overTimeDisabled,
                },
                {
                    text: WidgetNames.QUALITATIVE_METADATA_BREAKDOWN,
                    gridData: {
                        showFilter: true,
                        without_header: true,
                        title: WidgetNames.QUALITATIVE_METADATA_BREAKDOWN,
                        h: 7,
                        w: 5,
                        minH: 6,
                        minW: 4,
                    },
                    disable: disabledWithoutStringsType,
                },
                {
                    text: WidgetNames.METADATA_CONCEPT_BREAKDOWN,
                    gridData: {
                        showFilter: true,
                        without_header: true,
                        title: WidgetNames.METADATA_CONCEPT_BREAKDOWN,
                        h: 10,
                        w: 5,
                        minH: 6,
                        minW: 4,
                    },
                    disable: disabledWithoutStringsType,
                },
            ],
        },
        {
            text: "Volume",
            icon: <VolumeIcon />,
            children: [
                {
                    text: WidgetNames.VOLUME,
                    gridData: {
                        title: "Volumes > " + WidgetNames.VOLUME,
                        showFilter: true,
                        without_header: true,
                        minH: 10,
                        minW: 4,
                    },
                },
                {
                    text: WidgetNames.LARGEST_CONCEPT_MOVEMENT,
                    gridData: {
                        title: "Volumes > " + WidgetNames.LARGEST_CONCEPT_MOVEMENT,
                        showFilter: true,
                        without_header: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled,
                },
                {
                    text: WidgetNames.VOLUME_OVER_TIME,
                    gridData: {
                        title: "Volumes > " + WidgetNames.VOLUME_OVER_TIME,
                        showFilter: true,
                        minH: 10,
                        minW: 4,
                        lineChart: true,
                    },
                    disable: overTimeDisabled,
                },
                {
                    text: WidgetNames.SHARE_OF_VOICE_OVER_TIME,
                    gridData: {
                        title: "Volumes > " + WidgetNames.SHARE_OF_VOICE_OVER_TIME,
                        showFilter: true,
                        lineChart: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled,
                },
                {
                    text: WidgetNames.SHARE_OF_VOICE_OVER_TIME_BUBBLE,
                    gridData: {
                        title: "Volumes > " + WidgetNames.SHARE_OF_VOICE_OVER_TIME_BUBBLE,
                        showFilter: true,
                        without_header: true,
                        minH: 12,
                        minW: 6,
                    },
                    disable: overTimeDisabled,
                },
            ],
        },
        {
            text: "Sentiment",
            icon: <SentimentIcon />,
            children: [
                // {
                //     text: "Sentiment",
                //     gridData: {
                //         title: "Sentiment > Sentiment",
                //         showFilter: true,
                //     },
                //     sentimentStatus: sentimentStatus,
                //     disable: sentimentDisabled,
                // },
                // {
                //     text: "Largest Sentiment Movement",
                //     gridData: {
                //         title: "Sentiment > Largest Sentiment Movement",
                //         showFilter: true,
                //
                //     },
                //     sentimentStatus: sentimentStatus,
                //     disable: overTimeDisabled || sentimentDisabled,
                //     overTimeDisabled,
                // },
                {
                    text: WidgetNames.LARGEST_NET_SENTIMENT_MOVEMENT,
                    gridData: {
                        title: "Sentiment > " + WidgetNames.LARGEST_NET_SENTIMENT_MOVEMENT,
                        showFilter: true,
                        without_header: true,
                        minH: 12,
                        minW: 6,
                    },
                    sentimentStatus,
                    disable: overTimeDisabled || sentimentDisabled,
                },
                {
                    text: WidgetNames.SENTIMENT_OVER_TIME_LINE,
                    gridData: {
                        title: "Sentiment > " + WidgetNames.SENTIMENT_OVER_TIME_LINE,
                        showFilter: true,
                        lineChart: true,
                        minH: 10,
                        minW: 4,
                    },
                    sentimentStatus,
                    disable: overTimeDisabled || sentimentDisabled,
                },
                {
                    text: WidgetNames.OVERALL_SENTIMENT,
                    gridData: {
                        title: "Sentiment > " + WidgetNames.OVERALL_SENTIMENT,
                        showFilter: true,
                        h: 7,
                        w: 5,
                        minH: 6,
                        minW: 4,
                    },
                    sentimentStatus,
                    disable: sentimentDisabled,
                },
                // {
                //     text: "Sentiment Share Bar Chart",
                //     gridData: {
                //         title: "Sentiment > Sentiment Share Bar Chart",
                //         showFilter: true,
                //         sentimentFilter: true,
                //     },
                //     sentimentStatus: sentimentStatus,
                //     disable: sentimentDisabled,
                // },
                {
                    text: WidgetNames.SENTIMENT_SHARE,
                    gridData: {
                        title: "Sentiment > " + WidgetNames.SENTIMENT_SHARE,
                        showFilter: true,
                        sentimentFilter: true,
                        without_header: true,
                        h: 14,
                        minH: 13,
                        minW: 6,
                    },
                    sentimentStatus,
                    disable: sentimentDisabled,
                },
                // {
                //     text: "Net Sentiment for Concept over time",
                //     gridData: {
                //         title: "Sentiment > Net Sentiment for Concept over time",
                //         showFilter: true,
                //     },
                //     sentimentStatus: sentimentStatus,
                //     disable: overTimeDisabled || sentimentDisabled,
                //     overTimeDisabled,
                // },
            ],
        },
        {
            text: "Drivers",
            icon: <DriversIcon />,
            children: [
                {
                    text: WidgetNames.DRIVERS,
                    gridData: {
                        title: "Drivers > " + WidgetNames.DRIVERS,
                        showFilter: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: driversDisabled,
                    driversDisabled,
                },
                {
                    text: WidgetNames.DRIVERS_OVER_TIME,
                    gridData: {
                        title: "Drivers > " + WidgetNames.DRIVERS_OVER_TIME,
                        showFilter: true,
                        lineChart: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    overTimeDisabled,
                    driversDisabled,
                },
                {
                    text: WidgetNames.LARGEST_DRIVERS_MOVEMENT,
                    gridData: {
                        title: "Drivers > " + WidgetNames.LARGEST_DRIVERS_MOVEMENT,
                        showFilter: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    overTimeDisabled,
                    driversDisabled,
                },
                {
                    text: WidgetNames.DRIVERS_DIFFERENCE_FROM_AVERAGE,
                    gridData: {
                        title: "Drivers > " + WidgetNames.DRIVERS_DIFFERENCE_FROM_AVERAGE,
                        showFilter: true,
                        lineChart: true,
                        minH: 10,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    overTimeDisabled,
                    driversDisabled,
                },
                {
                    text: WidgetNames.IMPACT_SCORE,
                    gridData: {
                        title: "Drivers > " + WidgetNames.IMPACT_SCORE,
                        showFilter: true,
                        minH: 9,
                        minW: 4,
                    },
                    disable: overTimeDisabled || driversDisabled,
                    overTimeDisabled,
                    driversDisabled,
                },
            ],
        },
        {
            text: "What's New",
            icon: <MdOutlineFiberNew color={"#026d8a"} size={32} />,
            children: [
                {
                    text: WidgetNames.OUTLIER_PERCENTAGE,
                    gridData: {
                        showFilter: true,
                        title: WidgetNames.OUTLIER_PERCENTAGE,
                        minH: 10,
                        minW: 5,
                    },
                    disable: overTimeDisabled,
                },
            ],
        },
    ];

    const handleSidebarOpen = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleDrag = (e) => {
        e.preventDefault();
    };

    return (
        <>
            <div
                className={`sidebar-container 
                    ${!isSidebarOpen ? "sidebar-container-closed" : "sidebar-container-open"}`}
                onDragOver={handleDrag}
            >
                {isSidebarOpen && (
                    <>
                        <div className="sidebar-header">
                            <BiBarChartAlt2 className="sidebar-menu-item-icon lumi-text-blue" />
                            <h3 id="sidebar-header-text">{project?.name}</h3>
                            <VscLayoutSidebarLeft
                                className="sidebar-header-icon"
                                onClick={handleSidebarOpen}
                            />
                        </div>
                        <div className="sidebar-search-bar">
                            <HiSearch className="sidebar-header-icon" />
                            <input
                                type="text"
                                placeholder="Search"
                                className="sidebar-search-bar-input"
                            />
                        </div>
                        <div className="sidebar-menu" data-testid="sidebarMenu">
                            {sidebarItems.map((item) => (
                                <SidebarItem
                                    key={item.text}
                                    icon={item.icon}
                                    text={item.text}
                                >
                                    {item.children.map((submenu) => (
                                        <SubmenuItem
                                            key={submenu.text}
                                            text={submenu.text}
                                            gridData={submenu.gridData}
                                            disabled={submenu.disable}
                                            sentimentStatus={
                                                submenu.sentimentStatus
                                            }
                                            overTimeDisabled={
                                                submenu.overTimeDisabled
                                            }
                                            driversDisabled={
                                                submenu.driversDisabled
                                            }
                                        >
                                            {submenu.widget}
                                        </SubmenuItem>
                                    ))}
                                </SidebarItem>
                            ))}
                        </div>
                    </>
                )}
            </div>
            {!isSidebarOpen && (
                <div className="sidebar-button-container">
                    <VscLayoutSidebarRight onClick={handleSidebarOpen} />
                </div>
            )}
        </>
    );
}
